import { render } from "./EmAiman.vue?vue&type=template&id=54bcef16"
import script from "./EmAiman.vue?vue&type=script&lang=js"
export * from "./EmAiman.vue?vue&type=script&lang=js"

import "./EmAiman.vue?vue&type=style&index=0&id=54bcef16&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__